module.exports = __webpack_public_path__ + "lp/img/recording_disable.92ca04ce.svg";